import { graphql } from 'react-relay';

import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop.ts';

import type {
	useChangeCompanyHubPublishStateChangeHubPublishStateMutation as useChangeCompanyHubPublishStateChangeHubPublishStateMutation$data,
	useChangeCompanyHubPublishStateChangeHubPublishStateMutationVariables as useChangeCompanyHubPublishStateChangeHubPublishStateMutation$variables,
} from './__types__/useChangeCompanyHubPublishStateChangeHubPublishStateMutation.ts';
import { GraphQLFrontCoverState } from './__types__/ChangeHubPublishStateMutation.ts';
import ChangeHubPublishStateWriteQuery from './__generated__/ChangeHubPublishStateWriteQuery.graphql.ts';
import { useMutationInterop } from '@confluence/apollo-relay-interop/entry-points/useMutationInterop.ts';
import { writeQueryInterop } from '@confluence/apollo-relay-interop/entry-points/writeQuery.ts';
type useUpdateCompanyHubPublishStateResult = {
	data: useChangeCompanyHubPublishStateChangeHubPublishStateMutation$data | undefined;
	loading: boolean;
	error: ApolloErrorInterop | undefined;
	changeHubPublishState: (
		frontCoverState: GraphQLFrontCoverState,
	) => Promise<{ data?: useChangeCompanyHubPublishStateChangeHubPublishStateMutation$data }>;
};

export const useChangeCompanyHubPublishState = (): useUpdateCompanyHubPublishStateResult => {
	const [updateSiteLookAndFeel, { data, loading, error }] = useMutationInterop<
		useChangeCompanyHubPublishStateChangeHubPublishStateMutation$data,
		useChangeCompanyHubPublishStateChangeHubPublishStateMutation$variables
	>(
		graphql`
			mutation useChangeCompanyHubPublishStateChangeHubPublishStateMutation(
				$input: UpdateSiteLookAndFeelInput!
			) {
				updateSiteLookAndFeel(input: $input) {
					siteLookAndFeel {
						frontCoverState
					}
					success
					errors {
						message
						extensions {
							errorType
							statusCode
						}
					}
				}
			}
		`,
		{
			update: (_cache, { data }) => {
				writeQueryInterop({
					query: ChangeHubPublishStateWriteQuery,
					data: {
						siteSettings: {
							// Codegen is specifically configured to not add __typename when generating the types file,
							// so unfortunately ts-ignore is required here.
							// @ts-ignore
							__typename: 'SiteSettings',
							frontCover: {
								// Codegen is specifically configured to not add __typename when generating the types file,
								// so unfortunately ts-ignore is required here.
								// @ts-ignore
								__typename: 'FrontCover',
								frontCoverState: data?.updateSiteLookAndFeel?.siteLookAndFeel?.frontCoverState,
							},
						},
					},
				});
			},
		},
	);

	const changeHubPublishState = (frontCoverState: GraphQLFrontCoverState) =>
		updateSiteLookAndFeel({
			variables: {
				input: {
					faviconFiles: [],
					frontCoverState,
					showFrontCover: frontCoverState === GraphQLFrontCoverState.SHOWN,
				},
			},
		});

	return {
		data,
		loading,
		error,
		changeHubPublishState,
	};
};
